import type React from "react";
import "./ActivityCard.scss";
import type { ActivityType } from "@/entities/Activity/types/activityType";
import { AiFillCheckCircle, AiFillPlayCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import type { LessonType } from "../../../entities/Lesson/types/LessonType";
import { TypeToActivityIcon } from "../helpers";

type Props = {
	data: LessonType;
};

const ActivityCard: React.FC<Props> = ({ data }) => {
	return (
		<>
			{data?.activities?.map((activity: ActivityType, index) => {
				const IconComponent = TypeToActivityIcon(activity?.type);
				return (
					<div key={activity._id} className="lesson-details__activity-card">
						<div className="lesson-details__activity-icon-container">
							<IconComponent className="lesson-details__icon" />
						</div>
						<p>{activity?.title}</p>
						<div className="lesson-details__activity-card-right">
							<button type="button" id="play">
								<Link
									to={`/activity/${activity._id}?lesson_id=${data._id}&activity_type=${activity.type}`}
								>
									<AiFillPlayCircle />
								</Link>
							</button>
							<button type="button" id="check">
								<AiFillCheckCircle />
							</button>
						</div>
					</div>
				);
			})}
		</>
	);
};

export default ActivityCard;
